import { ThunkAction } from "../types";

import {
  createBroadcast as createBroadcastAction,
  getBroadcastAudience as getBroadcastAudienceAction,
  listCallsProgress,
  listMoreCallsProgress,
  updateCallProgress,
} from "../actions";
import { IBroadcast, IProfileListQuery } from "../api/APIClient";
import {
  AdminCallsListRequest,
  AdminCallUpdateRequest,
} from "dialup";
import memoize from "memoizee";
import { AdminAPI } from "dialup/ts/dist/admin_client";

export function createBroadcast(cast: IBroadcast): ThunkAction {
  return async (dispatch, _, { api }) => {
    try {
      dispatch(createBroadcastAction.request());

      const result = await api.createBroadcast(cast);

      dispatch(createBroadcastAction.success(result));
    } catch (err) {
      dispatch(createBroadcastAction.failure(err));
    }
  };
}

export function getBroadcastAudience(cast: IBroadcast): ThunkAction {
  return async (dispatch, _, { api }) => {
    try {
      dispatch(getBroadcastAudienceAction.request());

      const query = {
        ...cast.query,
        queryTime: cast.startTime,
      } as IProfileListQuery;

      const result = await api.listProfiles(query);

      dispatch(getBroadcastAudienceAction.success(result));
    } catch (err) {
      dispatch(getBroadcastAudienceAction.failure(err));
    }
  };
}

export function updateCall(req: AdminCallUpdateRequest): ThunkAction {
  return async (dispatch, _, { adminRPC }) => {
    try {
      dispatch(updateCallProgress.request());

      const result = await adminRPC.CallsAdminUpdate(req);

      dispatch(updateCallProgress.success(result));
    } catch (err) {
      dispatch(updateCallProgress.failure(err));
    }
  };
}

export function listCalls(): ThunkAction {
  return async (dispatch, _, { adminRPC }) => {
    try {
      dispatch(listCallsProgress.request());

      const result = await adminRPC.CallsAdminList({
        sort: "start:desc",
        limit: 50,
      });

      dispatch(listCallsProgress.success(result));
    } catch (err) {
      dispatch(listCallsProgress.failure(err));
    }
  };
}

const listMoreMemo = memoize(
  (key: string, rpc: AdminAPI, req: AdminCallsListRequest) =>
    rpc.CallsAdminList(req),
  {
    length: 1,
    promise: true,
  }
);

export function listMoreCalls(
  startIndex: number,
  endIndex: number
): ThunkAction {
  return async (dispatch, _, { adminRPC }) => {
    try {
      dispatch(listMoreCallsProgress.request());

      const request = {
        sort: "start:desc",
        offset: startIndex,
        limit: endIndex - startIndex,
      };

      const reply = await listMoreMemo(
        `${startIndex}-${endIndex}`,
        adminRPC,
        request
      );

      dispatch(
        listMoreCallsProgress.success({
          request,
          reply,
        })
      );
    } catch (err) {
      dispatch(listMoreCallsProgress.failure(err));
    }
  };
}



// WEBPACK FOOTER //
// ./src/thunks/callThunks.ts